import { flow } from 'mobx';
import { types } from 'mobx-state-tree';
import { ApiRequest } from './ApiRequest';
import { builds_api_url } from '../config/build-api-url';
import { BuildDto } from './Dtos/BuildDto';

export const BuildsApiGateway = types.model(
  'BuildsApiGateway',
  {
    apiRequest: ApiRequest
  })
  .views(() => ({
    getBuildsUrl(projectId: string): string {
      return `${builds_api_url}/api/${projectId}/builds`;
    }
  }))
  .views(self => ({
    getBuildUrl(projectId: string, buildId: string): string {
      return `${self.getBuildsUrl(projectId)}/${buildId}`;
    },
    getMakeBuildPublicUrl(projectId: string, buildId: string): string {
      return `${self.getBuildsUrl(projectId)}/makePublic/${buildId}`;
    },
    getMakeBuildPrivateUrl(projectId: string, buildId: string): string {
      return `${self.getBuildsUrl(projectId)}/makePrivate/${buildId}`;
    },
    getShareBuildUrl(projectId: string, buildId: string): string {
      return `${self.getBuildsUrl(projectId)}/shareBuild/${buildId}`;
    },
    getAddReleaseNotesToBuildUrl(projectId: string, buildId: string): string {
      return `${self.getBuildsUrl(projectId)}/addReleaseNotes/${buildId}`;
    },
    getClearReleaseNotesFromBuildUrl(projectId: string, buildId: string): string {
      return `${self.getBuildsUrl(projectId)}/clearReleaseNotes/${buildId}`;
    }
  }))
  .actions(self => ({
    getBuilds: flow(function* (projectId: string) {
      return yield self.apiRequest.get<BuildDto[]>(self.getBuildsUrl(projectId));
    }),
    getBuildsOfType: flow(function* (projectId: string, type: string) {
      return yield self.apiRequest.get<BuildDto[]>(`${self.getBuildsUrl(projectId)}?filterType=${type}`);
    }),
    getBuild: flow(function* (projectId: string, buildId: string) {
      return yield self.apiRequest.get<BuildDto>(self.getBuildUrl(projectId, buildId));
    }),
    makeBuildPublic: flow(function* (projectId: string, buildId: string) {
      return yield self.apiRequest.post(self.getMakeBuildPublicUrl(projectId, buildId), null);
    }),
    makeBuildPrivate: flow(function* (projectId: string, buildId: string) {
      return yield self.apiRequest.post(self.getMakeBuildPrivateUrl(projectId, buildId), null);
    }),
    shareBuild: flow(function* (projectId: string, buildId: string, emailAddresses: string[]) {
      return yield self.apiRequest.post(self.getShareBuildUrl(projectId, buildId), { 'Value': emailAddresses });
    }),
    addReleaseNotesToBuild: flow(function* (projectId: string, buildId: string, releaseNotes: string) {
      return yield self.apiRequest.post(self.getAddReleaseNotesToBuildUrl(projectId, buildId), { 'Value': releaseNotes });
    }),
    clearReleaseNotesFromBuild: flow(function* (projectId: string, buildId: string) {
      return yield self.apiRequest.get(self.getClearReleaseNotesFromBuildUrl(projectId, buildId));
    })
  }));


// export interface IBuildsApiGateway extends Instance<typeof BuildsApiGateway> {
// }
